import React from 'react';
import { useDispatch } from 'react-redux';
import { endEditingWhereabouts } from '@features/whereabouts/store/editMovements.duck';
import './edit-movements-mobile.scss';
import MobileEditMovementsContent from "../../../weekly-movements-setter/components/MobileEditMovementsContent";
import IconButton from "../../../../molecules/icon-button/IconButton";
import WeekFlicker from "@features/whereabouts/pages/team-movements/components/WeekFlicker";
import { IconTypes } from "@shared/ui/atoms/icon/Icon";
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { PrimaryButton } from "@shared/ui/atoms/buttons/PrimaryButton";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function EditMovementsMobile() {
  const dispatch = useDispatch();

  const save = () => {
    dispatch(endEditingWhereabouts());
  };

  return (
    <Column className="editMovementsMobile">
      <Row className="editMovementsMobile__header">
        <WeekFlicker className="editMovementsMobile__weekFlicker"/>
        <IconButton size="mediumlarge" className="editMovementsMobile__close" icon={IconTypes.Close}
                    onClick={() => dispatch(endEditingWhereabouts())}/>
      </Row>
      <MobileEditMovementsContent/>
      <div className="editMovementsMobile__controls">
        <PrimaryButton fullWidth={true} size={ButtonSize.Large} text="button.finish-and-save" click={() => save()}/>
      </div>
    </Column>
  )
}
